<template>
    <div class="p-grid p-fluid p-justify-center">
        <div style="width:600px">
            <Profile :user-id="userId"></Profile>
        </div>
    </div>
</template>

<script>
import Profile from '@/components/Users/Profile.vue';

export default {
    components: {
        Profile
    },
    props: {
        userId: String
    },
    data() {
        return {

        }
    }
}
</script>